export default __webpack_public_path__ + "static/media/step-2-de.6f0a1943.png";